import { gql } from '@src/lib/gql'

/**
 * Autosave a tool draft. Does not publish, notify, or touch a personal draft. Text that reads the same
 * as the stored draft writes nothing (`unchanged`), and an empty body discards the draft (`comment` is
 * null, `discarded` says whether there was one).
 */
export const UPSERT_TOOL_DRAFT = gql`
  mutation UpsertToolDraft($input: UpsertToolDraftInput!) {
    upsertToolDraft(input: $input) {
      comment {
        commentId
        body
        draftInboundCommentId
        draftEdited
        draftGeneratedAt
        draftSources
        storedFiles {
          storedFileId
          title
          fullUrl
          mimeType
          deletedAt
        }
      }
      discarded
      unchanged
    }
  }
`
